import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {Line, Doughnut} from 'react-chartjs-2';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";

class UserCampaignsArchivedItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            time_indicator: true,
            show: true,
            channels_style: {
                line: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204,237,243, 0.7)',
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(51,184,207, 0.9)',
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgb(153,219,231, 0.9)',
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgb(26,107,133, 0.9)',
                    }
                },
                doughnut: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204,237,243, 0.7)',
                        hoverBackgroundColor: 'rgba(204,237,243, 0.7)'
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(51,184,207, 0.9)',
                        hoverBackgroundColor: 'rgba(51,184,207, 0.9)'
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgb(153,219,231, 0.9)',
                        hoverBackgroundColor: 'rgb(153,219,231, 0.9)'
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgb(26,107,133, 0.9)',
                        hoverBackgroundColor: 'rgb(26,107,133, 0.9)'
                    }
                }
            },
            chartData: {
                labels: ["1", "2", "3", "4", "5", "6"],
                datasets: [{
                    backgroundColor: 'rgba(51,184,207,0.7)',
                    borderColor: '#33b8cf',
                    data: [],
                    borderWidth: 2,
                    radius: 4,
                    pointBackgroundColor: "#ffffff",
                    pointHoverBorderColor: '#33b8cf',
                    pointHoverBackgroundColor: "#ffffff",
                }]
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 5,
                        bottom: 0
                    }
                }
            },
            doughnutData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBorderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBackgroundColor: []
                }],
            },
            doughnutOptions: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                cutoutPercentage: 65,
                responsive: false,
                maintainAspectRatio: false,
            },
            open: false,
            chart: false,
            selected: "impressions",
            user_email: null,
            reseller: false,
        };
        this._updateChartData = this._updateChartData.bind(this);
    };

    componentWillMount() {
        this._setValues();
        this._updateUserData();
    }

    componentWillReceiveProps() {
        this.setState({
            data: this.props.data
        }, () => {
            this._updateChartData();
        });
    }

    _setValues() {
        this.setState({
            data: this.props.data
        }, () => {
            this._updateChartData();
        });
    }

    _updateUserData() {
        let user = userRegister.get();
        if (user) {
            this.setState({user_email: user.email, reseller: (user.reseller || user.inhouse)});
        }
    }

    _updateChartData() {
        let datasets = [];
        this.setState({show: false});

        //test

        try {
            let value = this.state.data.total_observations;
            value++;
            this.state.chartData.labels = [];
            for(let i = 0; i < value; i++){
                this.state.chartData.labels.push(i);
            }
        }catch (e) {
            console.log(e);
        }

        if (this.state.open) {

            try{
                let channels_observations = {};
                for(let i = 0; i < this.state.data.observations.length; i++){
                    for(let m = 0; m < this.state.data.channels.length; m++){
                        let key = this.state.data.channels[m];
                        if(channels_observations[key]){
                            if(this.state.data.observations[i].channels[key]){
                                channels_observations[key].observations.push(this.state.data.observations[i].channels[key][this.state.selected]?parseInt(this.state.data.observations[i].channels[key][this.state.selected]):0);
                            }
                        }else{
                            if(this.state.data.observations[i].channels[key]){
                                channels_observations[key] = {backgroundColor: null, observations: [0], title: null};
                                channels_observations[key].backgroundColor = this.state.channels_style.line[key].backgroundColor;
                                channels_observations[key].title = this.state.channels_style.line[key].title;
                                channels_observations[key].observations.push(this.state.data.observations[i].channels[key][this.state.selected]?parseInt(this.state.data.observations[i].channels[key][this.state.selected]):0);
                            }
                        }
                    }
                }
                for(let m = 0; m < this.state.data.channels.length; m++){
                    try{
                        let key = this.state.data.channels[m];
                        datasets.unshift({
                            data: channels_observations[key].observations,
                            backgroundColor: channels_observations[key].backgroundColor,
                            borderColor: 'transparent',
                            radius: 0,
                            label: channels_observations[key].title
                        });
                    }catch (e) {}
                }

                // SET DOUGHNUT DATA
                let observations = [];
                let channels = {};
                for(let i = 0; i < this.state.data.observations.length; i++){
                    for(let m = 0; m < this.state.data.channels.length; m++) {
                        let key = this.state.data.channels[m];
                        if(channels[key]){
                            if(this.state.data.observations[i].channels[key] && this.state.data.observations[i].channels[key][this.state.selected]){
                                channels[key].value = channels[key].value + parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                            }else{
                                channels[key].value = channels[key].value + 0;
                            }
                        }else{
                            channels[key] = {};
                            channels[key].title = this.state.channels_style.doughnut[key].title;
                            channels[key].backgroundColor = this.state.channels_style.doughnut[key].backgroundColor;
                            channels[key].hoverBackgroundColor = this.state.channels_style.doughnut[key].hoverBackgroundColor;
                            if(this.state.data.observations[i].channels[key] && this.state.data.observations[i].channels[key][this.state.selected]){
                                channels[key].value = parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                            }else{
                                channels[key].value = 0;
                            }
                        }
                    }
                }

                for(var key in channels){
                    this.state.doughnutData.labels.unshift(channels[key].title);
                    this.state.doughnutData.datasets[0].backgroundColor.unshift(channels[key].backgroundColor);
                    this.state.doughnutData.datasets[0].hoverBackgroundColor.unshift(channels[key].hoverBackgroundColor);
                    observations.unshift(channels[key].value);
                }

                this.state.doughnutData.datasets[0].data = observations;
                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    }),
                    doughnutData: this.state.doughnutData
                });
            }catch (e) {
               console.log(e);
            }

        }else{

            try{
                let observations = [0];
                for(let i = 0; i < this.state.data.observations.length; i++){
                    let value = 0;
                    for(let key in this.state.data.observations[i].channels){
                        if(this.state.data.observations[i].channels[key][this.state.selected]){
                            value = value + parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                        }
                    }
                    observations.push(value)
                }

                datasets = [{
                    backgroundColor: 'rgba(51,184,207,0.7)',
                    borderColor: '#33b8cf',
                    borderWidth: 2,
                    radius: 4,
                    pointBackgroundColor: "#ffffff",
                    pointHoverBorderColor: '#33b8cf',
                    pointHoverBackgroundColor: "#ffffff",
                    data: observations
                }];
                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    })
                });
            }catch (e) {
                console.log(e);
            }

        }
        setTimeout(() => {
            this.setState({show: true});
        }, 100);
    }

    _toggleCard() {
        this.setState({selected: this.state.open ? "impressions" : this.state.selected, open: !this.state.open}, () => {
            this._updateChartData();
        });
    }

    _edit() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running/" + this.state.data.hash);
    }

    _invoice() {
        window.open("https://invoice." + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + this.state.data.hash, '_blank');
    }

    _selectData(option) {
        if (this.state.data.status === "RUNNING") {
            this.setState({selected: option}, () => {
                this._updateChartData();
            });
        }
    }

    _archive(){
       this.props.setLoader(true);
       console.log('hej');
        /* dataRegister.archiveCampaign(salesChannelRegister.get('market'), langRegister.lang(), this.state.data.hash).then((response) => {
             //console.log(response);
             window.location.reload();
         }, (error) => {});
         */
    }

    _renderTotalClicks(data){
        let leads = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                if(data[i].channels[key].clicks){
                    leads = leads + parseInt(data[i].channels[key].clicks);
                }
            }
        }
        return leads;
    }

    _renderTotalImpressions(data){
        let impressions = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                if(data[i].channels[key].impressions){
                    impressions = impressions + parseInt(data[i].channels[key].impressions);
                }
            }
        }
        return impressions;
    }

    _renderPercentage(data) {
        if (data.days === 0) {
            return 0
        } else {
            let percentage = data.days / parseInt(data.duration);
            percentage = percentage * 100;
            return Math.floor(percentage);
        }
    }

    _renderIcon(key) {
        let color = "cardSubtitleInnerIconsItemColor" + key;
        let size = "cardSubtitleInnerIconsItem" + key;
        return (
            <div className={
                cx(Styles.cardSubtitleInnerIconsItem,
                    {
                        [Styles[color]]: this.state.open
                    })
            }>
                <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
            </div>
        )
    }

    _renderLang(lang) {
        if (lang === "sv") {
            return langRegister.lang() === "sv" ? "Svenska" : "Swedish"
        } else if (lang === "en") {
            return langRegister.lang() === "sv" ? "Engelska" : "English"
        }
    }

    _renderNumbers(x) {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("user-campaigns-running-item", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.data &&
                    <div id={this.state.id} className={
                        cx(Styles.card,
                            {
                                [Styles.cardOpen]: this.state.open
                            })
                    }>
                        {
                            this.state.data.status === "AWAITING_PAYMENT" &&
                            <div onClick={() => this._archive()} className={Styles.archiveButton}>
                                <img className={Styles.archiveButtonIcon} src={require('../../assets/images/close_icon_white_2.svg')}/>
                                adadadad
                            </div>
                        }
                        <div className={Styles.cardTitle}>
                            <span>{this.state.data.industry}</span>&nbsp;#{this.state.data.id}
                        </div>
                        <div className={Styles.cardSubtitle}>
                            <div className={Styles.cardSubtitleInner}>
                                <div
                                    className={Styles.cardSubtitleInnerText}>{this._renderLang(this.state.data.language)}</div>
                                <div className={Styles.cardSubtitleInnerIcons}>
                                    {
                                        this.state.data.channels &&
                                        this.state.data.channels.map((key, i) => {

                                            return (
                                                this._renderIcon(key)
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            {
                                this.state.reseller &&
                                <div className={Styles.cardTitleCompanyName}>{this.state.data.company_name}</div>
                            }
                        </div>
                        {
                            this.state.data.status === "RUNNING" && this.state.data.observations.length > 0 &&
                            <div onClick={() => this._toggleCard()} className={Styles.cardPlusButton}>
                                {
                                    !this.state.open &&
                                    <img className={Styles.cardPlusButtonIcon}
                                         src={require("../../assets/images/plus_sign_white.png")}/>
                                }
                                {
                                    this.state.open &&
                                    <img className={Styles.cardPlusButtonIcon}
                                         src={require("../../assets/images/minus_icon_white_small.png")}/>
                                }
                            </div>
                        }
                        <div className={
                            cx(Styles.cardLeft,
                                {
                                    [Styles.cardLeftOpen]: this.state.open
                                })
                        }>
                            {
                                this.state.time_indicator &&
                                <div onClick={() => this.setState({time_indicator: !this.state.time_indicator})}
                                     className={Styles.cardDonutChartContainer}>
                                    <svg viewBox="0 0 36 36" className={Styles.cardDonutChartContainerCircular}>
                                        <path className={Styles.cardDonutChartContainerBg}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <path className={Styles.cardDonutChartContainerCircle}
                                              stroke-dasharray={this._renderPercentage(this.state.data) + ", 100"}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <text x="15.5" y="19.35"
                                              className={Styles.cardDonutChartContainerPercentage}>{this._renderPercentage(this.state.data)}</text>
                                        <text x="22.5" y="19.00"
                                              className={Styles.cardDonutChartContainerPercentageSign}>%
                                        </text>
                                        <text x="18" y="24.35"
                                              className={Styles.cardDonutChartContainerTitle}>{this._renderText("item_2")}</text>
                                    </svg>
                                </div>
                                ||
                                <div onClick={() => this.setState({time_indicator: !this.state.time_indicator})}
                                     className={Styles.cardDonutChartContainer}>
                                    <svg viewBox="0 0 36 36" className={Styles.cardDonutChartContainerCircular}>
                                        <path className={Styles.cardDonutChartContainerBg}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <path className={Styles.cardDonutChartContainerCircle}
                                              stroke-dasharray={this._renderPercentage(this.state.data) + ", 100"}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <text x="14.5" y="19.35"
                                              className={Styles.cardDonutChartContainerPercentage}>{this.state.data.days}</text>
                                        <text x="22.5" y="19.4"
                                              className={Styles.cardDonutChartContainerPercentageSign}>/ {this.state.data.duration}</text>
                                        <text x="18" y="24.35"
                                              className={Styles.cardDonutChartContainerTitle}>{this._renderText("item_7")}</text>
                                    </svg>
                                </div>
                            }
                            <div className={Styles.cardDonutChartContainerInner}/>
                            {
                                this.state.data.status !== "AWAITING_PAYMENT" && this.state.data.status !== "READY" && this.state.data.status !== "AUTO_BILL" && this.state.data.status !== "UPCOMING" &&
                                <div onClick={() => this._edit()} className={
                                    cx(Styles.cardEditButton,
                                        {
                                            [Styles.cardEditButtonOpen]: this.state.open,
                                        })
                                }>
                                    {this._renderText("item_1")}
                                </div>
                            }
                            {
                                this.state.data.status === "ARCHIVED" &&
                                <div onClick={() => this._invoice()}
                                     className={cx(Styles.cardEditButton, Styles.cardEditButtonPayment)}>
                                    {this._renderText("item_11")}
                                </div>
                            }
                            <div className={Styles.cardStatusContainer}>
                                <div className={
                                    cx(Styles.cardStatus,
                                        {
                                            [Styles.cardStatusPending]: this.state.data.status === "ARCHIVED",
                                            [Styles.cardStatusProcessing]: (this.state.data.status === "READY" || this.state.data.status === "AUTO_BILL" || this.state.data.status === "UPCOMING")
                                        })
                                }>
                                    {
                                        (!this.state.data.lock_in || this.state.data.lock_in < 2) &&
                                        <div className={
                                            cx(Styles.cardStatusDot,
                                                {
                                                    [Styles.cardStatusPending]: this.state.data.status === "ARCHIVED",
                                                    [Styles.cardStatusProcessing]: (this.state.data.status === "READY" || this.state.data.status === "AUTO_BILL" || this.state.data.status === "UPCOMING")
                                                })
                                        }>
                                            &#9679;
                                        </div>
                                    }
                                    {
                                        (this.state.data.lock_in > 1) && this.state.data.status === "RUNNING" &&
                                        <img className={Styles.lock}
                                             src={require("../../assets/images/AB_lock_green.svg")}/>
                                    }
                                    {
                                        (this.state.data.lock_in > 1) && (this.state.data.status === "READY" || this.state.data.status === "AUTO_BILL" || this.state.data.status === "UPCOMING") &&
                                        <img className={Styles.lock}
                                             src={require("../../assets/images/AB_lock_grey.svg")}/>
                                    }
                                    {
                                        (this.state.data.lock_in > 1) && this.state.data.status === "ARCHIVED" &&
                                        <img className={Styles.lock}
                                             src={require("../../assets/images/AB_lock_red.svg")}/>
                                    }
                                    <div className={
                                        cx(Styles.cardStatusTitle,
                                            {
                                                [Styles.cardStatusPending]: this.state.data.status === "ARCHIVED",
                                                [Styles.cardStatusProcessing]: (this.state.data.status === "READY" || this.state.data.status === "AUTO_BILL" || this.state.data.status === "UPCOMING")
                                            })
                                    }>
                                        {
                                            this.state.data.status === "RUNNING" &&
                                            <span>{this._renderText("item_8")}</span>
                                        }
                                        {
                                            (this.state.data.status === "READY" || this.state.data.status === "AUTO_BILL" || this.state.data.status === "UPCOMING") &&
                                            <span>{this._renderText("item_9")}</span>
                                        }
                                        {
                                            this.state.data.status === "ARCHIVED" &&
                                            <span>{this._renderText("item_10")}</span>
                                        }
                                    </div>
                                    {
                                        this.state.data.redirect &&
                                        <div className={Styles.fwdStatus}>
                                            <img className={Styles.fwdStatusIcon} src={require("../../assets/images/arrow_forward.svg")}/>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={Styles.cardLeftInner}>
                                {
                                    this.state.show && this.state.data.observations.length > 0 &&
                                    <Line
                                        ref={ref => this.chartInstance = ref && ref.chartInstance}
                                        data={this.state.chartData}
                                        options={this.state.options}
                                    />
                                }
                            </div>
                            <div style={{width: (100 - this.state.percentage) + "%"}}
                                 className={Styles.cardLeftOverlay}/>
                        </div>
                        <div className={
                            cx(Styles.cardRight,
                                {
                                    [Styles.cardRightOpenMobile]: this.state.open
                                })
                        }>
                            <div onClick={() => this._selectData("impressions")} className={
                                cx(Styles.cardRightImpressions,
                                    {
                                        [Styles.cardRightOpen]: this.state.open
                                    })
                            }>
                                <div className={Styles.cardRightImpressionsInner}>
                                    <div className={Styles.cardRightImpressionsInnerTitle}>
                                        {this._renderText("item_3")}
                                    </div>
                                    <div className={Styles.cardRightImpressionsInnerValue}>
                                        {this._renderNumbers(this._renderTotalImpressions(this.state.data.observations))}
                                    </div>
                                </div>
                                {
                                    this.state.selected === "impressions" && this.state.data.status === "RUNNING" &&
                                    <div className={Styles.selector}/>
                                }
                            </div>
                            <div onClick={() => this._selectData("clicks")} className={
                                cx(Styles.cardRightClicks,
                                    {
                                        [Styles.cardRightOpen]: this.state.open
                                    })
                            }>
                                <div className={Styles.cardRightClicksInner}>
                                    <div className={Styles.cardRightClicksInnerTitle}>
                                        {this._renderText("item_4")}
                                    </div>
                                    <div className={Styles.cardRightClicksInnerValue}>
                                        {this._renderNumbers(this._renderTotalClicks(this.state.data.observations))}
                                    </div>
                                </div>
                                {
                                    this.state.selected === "clicks" &&
                                    <div className={Styles.selector}/>
                                }
                            </div>
                            {
                                this.state.open && this.state.data.observations.length > 0 &&
                                <div className={
                                    cx(Styles.cardRightDoughnut,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <Doughnut width={100} height={100} options={this.state.doughnutOptions}
                                              data={this.state.doughnutData}/>
                                </div>
                            }
                            {
                                this.state.open &&
                                <div onClick={() => this._selectData("call")} className={
                                    cx(Styles.cardRightImpressions,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_5")}
                                        </div>
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            {this._renderNumbers(this.state.call)}
                                        </div>
                                    </div>
                                    {
                                        this.state.selected === "call" &&
                                        <div className={Styles.selector}/>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default UserCampaignsArchivedItem;


// WEBPACK FOOTER //
// ./src/components/user-campaigns-archived-item/component.js